/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable lines-around-comment */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as Yup from 'yup';

import { CCCD_REGEX, PASSWORD_REGEX_NULLABLE, PHONE_RULE_REGEX_NULLABLE } from '@/constants';
import { useValidation } from '@/hooks/useValidation';
import { Shape } from '@/models';
import { FormWorkerModel } from '@/modules/worker/models';
import { vTrans } from '@/utils';

const { stringRequired, numberRequired } = useValidation('VALIDATION.FIELD.WORKER');

// QC bug #4 — create form previously only validated 5 fields (full_name,
// gender, password, phone, birthday). The form marks address, degree, bank
// info with `*` but didn't enforce, so users could submit incomplete NLD →
// downstream attendance / payroll / BHXH modules broke.
//
// Aligned with getWorkerUpdateFormSchema below so create + update share the
// same set of required fields. Birthday + password kept create-only.
function getWorkerFormSchema() {
  return Yup.object<Shape<FormWorkerModel>>({
    full_name: stringRequired('FULL_NAME'),
    gender: stringRequired('GENDER'),
    password: stringRequired('PASSWORD'),
    phone: stringRequired('PHONE').matches(
      PHONE_RULE_REGEX_NULLABLE,
      vTrans.matches('VALIDATION.FIELD.HR.PHONE_NUMBER')
    ),
    birthday: stringRequired('BIRTHDAY'),
    id_number: stringRequired('ID_NUMBER')
      .test(
        'is-valid-cccd',
        vTrans.matches('VALIDATION.FIELD.WORKER.CCCD_FORMAT'),
        (value) => !value || CCCD_REGEX.test(value)
      ),
    province_code: stringRequired('PROVINCE'),
    district_code: stringRequired('DISTRICT'),
    ward_code: stringRequired('WARD'),
    full_address: stringRequired('FULL_ADDRESS'),
    degree_id: stringRequired('DEGREE'),
    bank_name: stringRequired('BANK_NAME'),
    bank_owner_account_name: stringRequired('BANK_OWNER_ACCOUNT_NAME'),
    bank_owner_account_number: stringRequired('BANK_OWNER_ACCOUNT_NUMBER'),
  });
}

// QC #46 — popup "Thêm data" → "Tạo NLĐ mới" only renders 5 fields
// (full_name, gender, phone, birthday, password). The strict
// getWorkerFormSchema() requires 13 fields, so rhf silently blocked submit
// → users clicked Tạo and nothing happened. Quick-create needs its own
// trimmed schema; the missing fields are filled in later on the worker
// detail page.
function getWorkerQuickCreateSchema() {
  return Yup.object<Shape<FormWorkerModel>>({
    full_name: stringRequired('FULL_NAME'),
    gender: stringRequired('GENDER'),
    password: stringRequired('PASSWORD'),
    phone: stringRequired('PHONE').matches(
      PHONE_RULE_REGEX_NULLABLE,
      vTrans.matches('VALIDATION.FIELD.HR.PHONE_NUMBER')
    ),
    birthday: stringRequired('BIRTHDAY'),
    // Bug 138 (D): keep join_date in the resolved values so the manually
    // chosen "Ngày tham gia" is submitted and persisted on quick-create.
    join_date: Yup.string(),
  });
}

function getWorkerUpdateFormSchema() {
  return Yup.object<Shape<FormWorkerModel>>({
    full_name: stringRequired('FULL_NAME'),
    gender: stringRequired('GENDER'),
    num_experience: numberRequired('NUM_EXPERIENCE'),
    phone: stringRequired('PHONE'),
    id_number: stringRequired('ID_NUMBER')
      .test(
        'is-valid-cccd',
        vTrans.matches('VALIDATION.FIELD.WORKER.CCCD_FORMAT'),
        (value) => !value || CCCD_REGEX.test(value)
      ),
    province_code: stringRequired('PROVINCE'),
    district_code: stringRequired('DISTRICT'),
    ward_code: stringRequired('WARD'),
    full_address: stringRequired('FULL_ADDRESS'),
    degree_id: stringRequired('DEGREE'),
    bank_name: stringRequired('BANK_NAME'),
    bank_owner_account_name: stringRequired('BANK_OWNER_ACCOUNT_NAME'),
    bank_owner_account_number: stringRequired('BANK_OWNER_ACCOUNT_NUMBER'),
  });
}

export { getWorkerFormSchema, getWorkerQuickCreateSchema, getWorkerUpdateFormSchema };
